import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsEventstoreComponent } from './simple-icons-eventstore.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsEventstoreComponent ],
    exports:      [ SimpleIconsEventstoreComponent ],
    bootstrap:    []
})
export class SimpleIconsEventstoreModule {}
